import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { IconNotificationCenter } from '@xingternal/icons';

import { JobPostingModule } from '@/components/job-posting-module';
import { JDPModuleName } from '@/components/job-posting/types';
import { JobAlertContext } from '@/contexts';
import { useBreakpoints } from '@/hooks';

import { ScrollTrackingModuleWrapper } from '../scroll-tracking-module-wrapper';

import * as S from './create-alert-module-component.styles';

export const CreateAlertModule: React.FC<{ moduleName: JDPModuleName }> = ({ moduleName }) => {
  const { isMobile } = useBreakpoints();

  const {
    toggleAlertLightbox,
    summary: { keywords, location },
  } = useContext(JobAlertContext);

  const openAlertLightbox = (): void => {
    toggleAlertLightbox({ actionOrigin: 'jobs_button' });
  };

  return (
    <ScrollTrackingModuleWrapper moduleTrackingName={moduleName}>
      <JobPostingModule>
        <S.CreateAlertContainer size={12}>
          {isMobile ? <S.IconAlert width={64} height={64} /> : null}
          <S.CreateAlertBody>
            <S.StyledHeadline size="medium">
              {keywords ? (
                <FormattedMessage
                  id="JOBS_POSTING_CREATE_ALERT_MODULE_KEYWORDS"
                  values={{ keywords: <strong>{keywords}</strong> }}
                />
              ) : (
                <FormattedMessage id="JOBS_POSTING_CREATE_ALERT_MODULE_LOCATION" values={{ location }} />
              )}
            </S.StyledHeadline>
            <S.StyledButton
              variant="secondary"
              size="small"
              icon={!isMobile ? IconNotificationCenter : null}
              sizeWide="medium"
              onClick={openAlertLightbox}
              data-soft-login-fenced
            >
              <FormattedMessage id="JOBS_POSTING_CREATE_ALERT_MODULE_CTA" />
            </S.StyledButton>
          </S.CreateAlertBody>
        </S.CreateAlertContainer>
      </JobPostingModule>
    </ScrollTrackingModuleWrapper>
  );
};
